export default __webpack_public_path__ + "static/cover-video-d2430f91244f9b82e556c8b2a75e40a9.mp4";